import React, { useState } from 'react';
import style from '../css/SwiperNews.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

import news from '../utils/news';
import News from './cards/News';

// Css pagination = Especialista.css

const SwiperNews = () => {
	const [swiper, setSwiper] = useState();

	const pagination = {
		clickable: false,
		bulletClass: 'swiper-pagination-news',
		bulletActiveClass: 'swiper-pagination-news-active',
		horizontalClass: 'swiper-pagination-horizontal-news',
		renderBullet: function (i, className) {
			return '<div class="' + className + '"> </div>';
		},
	};

	return (
		<section className={style.mainSection}>
			<div className={style.arrowButtonsContainer}>
				<div className={style.arrowButton} onClick={() => swiper.slidePrev()}>
					<MdKeyboardArrowLeft />
				</div>
				<div className={style.arrowButton} onClick={() => swiper.slideNext()}>
					<MdKeyboardArrowRight />
				</div>
			</div>
			<div className={style.mainContainer}>
				<div className={style.titles}>
					<div className={style.bubble}>
						<span>LIBEL NEWS</span>
					</div>

					<h1>¡INSCRÍBETE AHORA!</h1>

					<p>Se parte de nuestra comunidad y descubre nuestros próximos eventos y entrenamientos</p>
				</div>

				<Swiper
					className={style.swiperNews}
					autoplay={{
						delay: 5000,
					}}
					slidesPerView={1}
					spaceBetween={10}
					onSwiper={(swiper) => setSwiper(swiper)}
					loop={true}
					// loopedSlides={4}
					pagination={pagination}
					modules={[Autoplay, Pagination]}
					// breakpoints={{
					// 	1131: {
					// 		slidesPerView: 3,
					// 		spaceBetween: 0,
					// 	},
					// 	948: {
					// 		slidesPerView: 2,
					// 		spaceBetween: 0,
					// 	},
					// }}
				>
					{news.map((news, i) => (
						<SwiperSlide className={style.swiperSlide} key={i}>
							<News
								title={news.title}
								page={news.page}
								image={news.image}
								imageMobile={news.imageMobile}
								description={news.description}
							/>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</section>
	);
};

export default SwiperNews;
